import { AxiosResponse } from 'axios';

import { IArea } from 'components/shared/Assets/shared/Form/Document/types';
import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';

import { getAccountId } from './auth';

const decoratedAxiosGet = axiosGetAutoCancelDecorator();

type GetAreasByCountyIdResponse = {
  data: IArea[];
};

export const getAreasByCountryId = async (countryId?: string): Promise<GetAreasByCountyIdResponse> => {
  const response = (await decoratedAxiosGet(
    `acc/${getAccountId()}/areas?country_id=${countryId}`,
  )) as AxiosResponse<GetAreasByCountyIdResponse>;

  return response.data;
};
